import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { url } from '../../../constants/routes';
import { connect } from '../../../reducers/index';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import AssistGraphic from '../img/assist-graphic.svg';
// import AssistGraphic02 from '../img/assist-prof-holding-map-graphic.svg';

const AssistPage = props => {
  return (
    <EducationModuleLayout
      progressStage={1}
      childTitle="Assist"
      progressType="assist"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <h2 className="txt-green no-bold no-margin">
                ASSIST: How to Assist Someone Experiencing a Mental Health Challenge
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <img
                className="img-block img-responsive"
                src={AssistGraphic}
                alt="Help is available"
              />
              <p>
                Once you've identified the reasons you’re concerned about someone, the next step is to 
                have a meaningful conversation as a way to support them. There are <strong>six components</strong> to 
                assisting someone. These are:
              </p>

              <ol className="list">
                <li className="list-item">
                  Choose a place and time
                </li>
                <li className="list-item">
                  Validate their feelings
                </li>
                <li className="list-item">
                  Listen actively
                </li>
                <li className="list-item">
                  Don’t promise to keep secrets
                </li>
                <li className="list-item">
                  Avoid giving advice
                </li>
                <li className="list-item">
                  Instill a sense of hope
                </li>
              </ol>

              <p>
                Next, we will be reviewing these <strong>six components</strong>. 
                For each component, read over the description and reflect on your comfort level. 
                Having helpful and supportive conversations is a skill that can be developed through 
                practice and reflection.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-green previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer to={url.ASSIST_B} className="btn btn-green next">
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

AssistPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const AssistB = connect.role(AssistPage);

export default AssistB;



// WEBPACK FOOTER //
// ./src/containers/Assist/AssistA/index.jsx